import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import { useStore } from "vuex";
import { ProductIds } from "@/config/constants";
import ApplicationInfoLOC from "@/components/application-info/ApplicationInfoLOC.vue";
import ApplicationInfoPEL from "@/components/application-info/ApplicationInfoPEL.vue";
import ApplicationInfoREFI from "@/components/application-info/ApplicationInfoREFI.vue";
import RefiLoanDetailsModal from "@/components/modals-refi/RefiLoanDetailsModal.vue";
import RefiLoanConfigurationModal from "@/components/modals-refi/RefiLoanConfigurationModal.vue";
import ConfirmYourRefinanceDetailsModal from "@/components/modals-refi/ConfirmYourRefinanceDetailsModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationInfo',
  props: {
  id: {
    type: String,
  },
  application: {
    type: Object,
    required: true,
  },
  applicant: {
    type: Object,
    required: true,
  },
},
  emits: ["complete", "hydrateStore"],
  setup(__props, { emit: __emit }) {

const props = __props;

const store = useStore();

const emit = __emit;

const productTypeId = computed(() => store?.state?.appData?.application?.productTypeId);
const currentlyActiveModal = computed(() => store.getters["applicationInfoModule/ModalComponent"]);
const applicationInfoComponent = computed(() => {
  return getApplicationInfoComponent();
});
const modalComponent = computed(() => {
  return getModalComponent();
});
const applicantInfoComponentProps = computed(() => {
  switch (applicationInfoComponent.value) {
    case ApplicationInfoLOC:
      return { application: props.application, applicant: props.applicant };
    case ApplicationInfoREFI:
      return { application: props.application };
    default:
      return undefined;
  }
});
const currentListeners = computed(() => {
  switch (applicationInfoComponent.value) {
    default:
      return {};
  }
});

function getModalComponent() {
  switch (currentlyActiveModal.value) {
    case "LoanDetails":
      return RefiLoanDetailsModal;
    case "InterestRateAndLoanTerm":
      return RefiLoanConfigurationModal;
    case "ConfirmYourRefinanceDetails":
      return ConfirmYourRefinanceDetailsModal;
    default:
      return;
  }
}

function getApplicationInfoComponent() {
  switch (productTypeId.value) {
    case ProductIds.REFI:
      return ApplicationInfoREFI;
    case ProductIds.LOC:
      return ApplicationInfoLOC;
    case ProductIds.PEL:
      return ApplicationInfoPEL;
    default:
      return undefined;
  }
}

function handleHydrateStoreEvent() {
  emit("hydrateStore");
}

function handleCompleteEvent(event: any) {
  emit("complete", event);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(applicationInfoComponent.value), _mergeProps(applicantInfoComponentProps.value, _toHandlers(currentListeners.value)), null, 16)),
    (_openBlock(), _createBlock(_resolveDynamicComponent(modalComponent.value)))
  ], 64))
}
}

})